import React from "react";
import PropTypes from "prop-types";
import { Paper, withStyles } from "@material-ui/core";

import Duplicado from "./Duplicado";
import whatsapp from "./Whatsapp";
import { Tipografia } from "../../../../_common";

const TIPOS_EVENTO = {
  DUPLICADO: 1,
  WHATSAPP: 2,
};

const Components = {
  [TIPOS_EVENTO.DUPLICADO]: Duplicado,
  [TIPOS_EVENTO.WHATSAPP]: whatsapp,
};

TimeLineItemEventoCustom.propTypes = {
  itemTimeline: PropTypes.shape({
    usuarioNome: PropTypes.string,
    eventoCustom: PropTypes.object,
  }),
  isTimelineAtividades: PropTypes.bool,
};

function TimeLineItemEventoCustom({ itemTimeline, isTimelineAtividades, classes }) {
  const { eventoCustom } = itemTimeline;
  const Component = Components[(itemTimeline?.eventoCustom?.tipo)];

  if (!Component) {
    return null;
  }
  return (
    <Paper className={classes.container} elevation={isTimelineAtividades ? 0 : 1}>
      <Tipografia tipo="notaLegendas" cor="darkSecondaryText" className={classes.textoResponsavel}>
        {itemTimeline.usuarioNome}
      </Tipografia>
      <div>
        <Component eventoCustom={eventoCustom} />
      </div>
    </Paper>
  );
}

export default withStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    padding: "8px 8px 0px 8px",
  },
  textoResponsavel: {
    whiteSpace: "pre-line",
    paddingBottom: 5,
  },
})(TimeLineItemEventoCustom);
